export function buildTechnicianFilterOptions({
  selectedTechnicianColumnFilters,
  previsaoWithCounts = [],
  citiesWithCounts = [],
  bairrosWithCounts = [],
  clientesWithCounts = [],
  tiposOSWithCounts = [],
  slasWithCounts = [],
  equipamentosWithCounts = [],
  defeitoDescricaoWithCounts = [],
  defeitoAlertWithCounts = [],
  defeitoClassificationWithCounts = [],
  defeitoSeverityWithCounts = [],
}) {
  const tech = selectedTechnicianColumnFilters;
  const defeitoSubmenuSelectionsCount =
    tech.defeitoDescricao.length +
    tech.defeitoAlert.length +
    tech.defeitoClassification.length +
    tech.defeitoSeverity.length;

  const retornoCount =
    tech.retorno === 'nao' ||
    (tech.retorno && typeof tech.retorno === 'object' && (tech.retorno.aguardando || tech.retorno.liberado))
      ? 1
      : 0;

  const filterOptions = [
    {
      key: 'clearAll',
      label: 'Limpar filtros',
      count: 0,
      isClearAction: true,
    },
    {
      key: 'previsao',
      label: 'Previsão',
      count: tech.previsao.length,
      description: `Filtrar por previsão (${previsaoWithCounts.length} disponíveis)`,
    },
    {
      key: 'retorno',
      label: 'Retorno',
      count: retornoCount,
      retornoMode: 'technician',
      description: 'Retornos (aguardando/liberado) ou não exibir',
    },
    {
      key: 'cidade',
      label: 'UF e cidade',
      count: tech.cidade.length,
      description: `Filtrar por UF e localização (${citiesWithCounts.length} disponíveis)`,
    },
    {
      key: 'bairro',
      label: 'Bairro',
      count: tech.bairro.length,
      description: `Filtrar por bairro (${bairrosWithCounts.length} disponíveis)`,
    },
    {
      key: 'cliente',
      label: 'Cliente',
      count: tech.cliente.length,
      description: `Filtrar por cliente (${clientesWithCounts.length} disponíveis)`,
    },
    {
      key: 'tipoOS',
      label: 'Tipo de OS',
      count: tech.tipoOS.length,
      description: `Filtrar por tipo de OS (${tiposOSWithCounts.length} disponíveis)`,
    },
    {
      key: 'sla',
      label: 'SLA',
      count: tech.sla.length,
      description: `Filtrar por SLA (${slasWithCounts.length} disponíveis)`,
    },
    {
      key: 'equipamento',
      label: 'Equipamento',
      count: tech.equipamento.length,
      description: `Filtrar por equipamento (${equipamentosWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoSubmenu',
      label: 'Defeitos',
      count: defeitoSubmenuSelectionsCount,
      openSubmenu: true,
      description: 'Filtrar por descrição, alerta, classificação e criticidade',
    },
    {
      key: 'osFutura',
      label: 'OS futura',
      count: tech.osFuturaRange ? 1 : 0,
      description: 'Filtrar OS futura por período',
    },
  ];

  const defeitoSubOptions = [
    {
      key: 'defeitoDescricao',
      label: 'Defeito',
      count: tech.defeitoDescricao.length,
      description: `Descrição do defeito (${defeitoDescricaoWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoAlert',
      label: 'Código de alerta',
      count: tech.defeitoAlert.length,
      description: `Código de alerta (${defeitoAlertWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoClassification',
      label: 'Classificação',
      count: tech.defeitoClassification.length,
      description: `Classificação (${defeitoClassificationWithCounts.length} disponíveis)`,
    },
    {
      key: 'defeitoSeverity',
      label: 'Criticidade',
      count: tech.defeitoSeverity.length,
      description: `Criticidade (${defeitoSeverityWithCounts.length} disponíveis)`,
    },
  ];

  return { filterOptions, defeitoSubOptions };
}
